module.exports = __webpack_public_path__ + "static/media/pingxx.5f0f586f.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/pingxx.ico
// module id = 167
// module chunks = 0